import { Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Route, Router, Routes, Scroll } from '@angular/router';
import { BehaviorSubject, filter, mergeMap, Observable, of } from 'rxjs';
import { Breadcrumb } from '../models/breadcrumb.interface';
import { PlatformLocation } from '@angular/common';

@Injectable()
export class BreadcrumbService {
  // Subject emitting the breadcrumb hierarchy
  private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

  items: Breadcrumb[] = [];

  private routes: Routes;

  // Observable exposing the breadcrumb hierarchy
  readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

  constructor(private route: ActivatedRoute, private platformLocation: PlatformLocation) {
    this.processBreadcrumbItems();
  }

  /**
   * Processes breadcrumb items after component was rendered
   */
  private processBreadcrumbItems(): void {
    this.items.splice(0, this.items.length);
    const baseUrl = this.platformLocation.href.includes('#') ? '#' : '';
    const data = this.createBreadcrumbs(this.route.root, baseUrl);
    this.items.push(...data);
    this._breadcrumbs$.next(this.items);
  }

  /**
   * Creates breadcrumb from routing params
   * @param route Activated route
   * @param url Url of item to navigate
   * @param breadcrumbs Collection of breadcrumbs parents
   * @returns Collection of breadcrumbs @see {@link AsolBreadcrumbItem}
   */
  private createBreadcrumbs(
    route: ActivatedRoute,
    url = '',
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      const label = child.snapshot.data['breadcrumb'];
      if (label) {
        breadcrumbs.push({
          label: label,
          url,
        });
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }

    console.log(breadcrumbs);

    return breadcrumbs;
  }
}